<fieldset [disabled]="formState ==='Submitting'">
  <app-component-loading *ngIf="formState==='Submitting'" [size]="'inline'"  style="margin-left: 20px;"></app-component-loading>
  <div  [style.opacity]="formState === 'Submitting'? 0.5 : 1" >
  <h1>{{ 'MODALS.HEADERS.SELECT_PROJECT' | translate }}</h1>
  <p style="white-space: pre-line">{{ 'MODALS.TEXT.SELECT_PROJECT' | translate }}</p>
  <div class="list-group">
  <a (click)="onSetProject(null, true)"
   class="list-group-item list-group-item-action"
      data-action="selectProject"
      style="color:var(--primaryColor); opacity: 0.8;">
      <i class="bi bi-person-square"></i>
      <strong> {{ 'CONTRACTS.FIELDS.PRIVATE'|translate }} </strong>
  </a>
   
   <a  
   (click)="formState !=='Submitting'? onSetProject(project.project.guid, modal) : null"
   *ngFor="let project of currentMember?.projects_list"
   [attr.data-project-guid]="project?.project?.guid"
   class="list-group-item list-group-item-action"
   data-action="selectProject"
   >
   <strong>
       <i *ngIf="project.project.subtype !== 'MEMBER'"
       class="bi bi-buildings"
       ></i>
       <i *ngIf="project.project.subtype === 'MEMBER'"
       class="bi bi-person-square"
       ></i>
          {{ project?.project?.name }}
      </strong>
    </a>
  </div>
</div>
</fieldset>